import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Subject } from 'src/app/_models/subject';

import { AdminService } from 'src/app/_services/admin.service';
import { SyllabusService } from 'src/app/_services/syllabus.service';


@Component({
  selector: 'app-admin-subject-new',
  templateUrl: './admin-subject-new.component.html',
  styleUrls: ['./admin-subject-new.component.css']
})

export class AdminSubjectNewComponent implements OnInit {

   myForm;
  levels=[]
  syllabusList=[]
  @Output() addSubjectSaveEvent = new EventEmitter<string>()
  @Output() addSubjectCloseModalEvent = new EventEmitter<string>()
  @Input() server_level_id=0
  @Input() level_name=""
  @Input() level_country_name=""
  constructor(private adminService:AdminService,private syllabusService:SyllabusService) { }

  get f() {
    return this.myForm.controls
  }
  ngOnInit(): void {
    this.adminService.getLevels().subscribe(
      data=>{this.levels=data}
    )
    this.syllabusService.getSyllabusMinDataList().subscribe(
      data=>{this.syllabusList=data}
    )
    this.initMainFormFresh()
  }
  form_submit() {
    let subject=new Subject()
    subject.name =  "Math"
    subject.server_level_id = this.server_level_id

    subject.server_syllabus_id = this.f.syllabus.value

    this.addSubjectSaveEvent.emit(subject.formData(this.level_country_name))
    this.closeModal()
  }
  closeModal(){
     this.addSubjectCloseModalEvent.emit("close")
  }

  initMainFormFresh(){
    this.myForm=new FormGroup({
      name: new FormControl('', Validators.compose([Validators.required,Validators.minLength(3)])),
      description: new FormControl("",Validators.compose([Validators.required,Validators.minLength(3)])),
      syllabus:new FormControl('',Validators.required)
    });
  }
}
